module.exports = __webpack_public_path__ + "static/media/0359_Small.6c75cf06.jpg";